<template>
    <b-modal v-model="modal_definitions.show"
             centered
             title="Definiciones"
             hide-footer
             size="lg"
    >
        <b-list-group>
            <b-list-group-item v-for="(definition, i) in definitions"
                               :key="i"
                               class="flex-column align-items-start"
            >
                <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-1">{{ definition.word }}</h5>
                </div>

                <p class="mb-1">
                    {{ definition.definition }}
                </p>
            </b-list-group-item>
        </b-list-group>
    </b-modal>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'modal_definitions',
    computed: {
        ...mapState('calculator', [
            'modal_definitions',
            'definitions'
        ])
    }
};
</script>

<style scoped>

</style>
